module.exports = __webpack_public_path__ + "static/media/400067_01.26ff8962.png";